import dragon from './dragon_invite/es.json';
import exchangeShop from './exchange_shop/es.json';

export default {
    ...dragon,
    ...exchangeShop
};
